var SalesHomePagePresenter = /** @class */ (function () {
    function SalesHomePagePresenter(actions, usecases) {
        this.actions = actions;
        this.usecases = usecases;
    }
    SalesHomePagePresenter.prototype.getDownloadNRData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.downloadNRData.execute({
                onSuccess: function (downloadLead) {
                    resolve(downloadLead);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesHomePagePresenter.prototype.getDownloadEngagementData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.downloadEngagementData.execute({
                onSuccess: function (downloadLead) {
                    resolve(downloadLead);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesHomePagePresenter.prototype.getDownloadLeadData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecases.downloadLeadsData.execute({
                onSuccess: function (downloadLead) {
                    resolve(downloadLead);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    //engagementDashboardStatus
    SalesHomePagePresenter.prototype.getEngagementDashboardStatus = function (req) {
        var _this = this;
        this.actions.engagementDashboardStatus.hideError("engagementDashboardStatus");
        this.actions.engagementDashboardStatus.loader("engagementDashboardStatus");
        this.usecases.engagementDashboardStatus.execute({
            onSuccess: function (data) {
                _this.actions.engagementDashboardStatus.getEngagementDashboardStatus(data, "engagementDashboardStatus");
                _this.actions.engagementDashboardStatus.stopLoader("engagementDashboardStatus");
            },
            onError: function (error) {
                _this.actions.engagementDashboard.setError({ isOpen: true, error: error }, "engagementDashboardStatus");
                _this.actions.engagementDashboard.stopLoader("engagementDashboardStatus");
            },
        }, req);
    };
    SalesHomePagePresenter.prototype.getEngagementDashboard = function (req) {
        var _this = this;
        this.actions.engagementDashboard.hideError("engagementDashboard");
        this.actions.engagementDashboard.loader("engagementDashboard");
        this.usecases.engagementDashboard.execute({
            onSuccess: function (data) {
                _this.actions.engagementDashboard.getEngagementDashboard(data, "engagementDashboard");
                _this.actions.engagementDashboard.stopLoader("engagementDashboard");
            },
            onError: function (error) {
                _this.actions.engagementDashboard.setError({ isOpen: true, error: error }, "engagementDashboard");
                _this.actions.engagementDashboard.stopLoader("engagementDashboard");
            },
        }, req);
    };
    SalesHomePagePresenter.prototype.getExpiringLeads = function (req) {
        var _this = this;
        this.actions.eventActivities.expiringLeads.hideError("expiringLeads");
        this.actions.eventActivities.expiringLeads.loader("expiringLeads");
        this.usecases.eventActivities.expiringLeads.execute({
            onSuccess: function (data) {
                _this.actions.eventActivities.expiringLeads.updateExpiringLeads(data, "expiringLeads");
                _this.actions.eventActivities.expiringLeads.stopLoader("expiringLeads");
            },
            onError: function (error) {
                _this.actions.eventActivities.expiringLeads.setError({ isOpen: true, error: error }, "expiringLeads");
                _this.actions.eventActivities.expiringLeads.stopLoader("expiringLeads");
            },
        }, req);
    };
    SalesHomePagePresenter.prototype.getUpcomingMeetings = function (req) {
        var _this = this;
        this.actions.eventActivities.upcomingMeetings.hideError("upcomingMeetings");
        this.actions.eventActivities.upcomingMeetings.loader("upcomingMeetings");
        this.usecases.eventActivities.upcomingMeetings.execute({
            onSuccess: function (data) {
                _this.actions.eventActivities.upcomingMeetings.getUpcomingMeeting(data, "upcomingMeetings");
                _this.actions.eventActivities.upcomingMeetings.stopLoader("upcomingMeetings");
            },
            onError: function (error) {
                _this.actions.eventActivities.upcomingEvents.setError({ isOpen: true, error: error }, "upcomingMeetings");
                _this.actions.eventActivities.upcomingEvents.stopLoader("upcomingMeetings");
            },
        }, req);
    };
    SalesHomePagePresenter.prototype.getUpcomingEvents = function (req) {
        var _this = this;
        this.actions.eventActivities.upcomingEvents.hideError("upcomingEvents");
        this.actions.eventActivities.upcomingEvents.loader("upcomingEvents");
        this.usecases.eventActivities.upcomingEvents.execute({
            onSuccess: function (data) {
                console.log("success", data);
                _this.actions.eventActivities.upcomingEvents.getUpcomingEvents(data, "upcomingEvents");
                _this.actions.eventActivities.upcomingEvents.stopLoader("upcomingEvents");
            },
            onError: function (error) {
                _this.actions.eventActivities.upcomingEvents.setError({ isOpen: true, error: error }, "upcomingEvents");
                _this.actions.eventActivities.upcomingEvents.stopLoader("upcomingEvents");
            },
        }, req);
    };
    return SalesHomePagePresenter;
}());
export default SalesHomePagePresenter;
